<script lang="ts">
    import Footer from "./footer/Footer.svelte";
    import Head from "./header/Head.svelte";
    import Navbar from "./header/Navbar.svelte";
    import { appManager } from "./AppManagerStore";
    import AngleLeft from "./svg/shapes/AngleLeft.svelte";
    import { _ } from "svelte-i18n";
</script>

<svelte:head>
    <title>ANYWAYS | {$_("about.pagetitle")}</title>
</svelte:head>

<Navbar isDark={false} isFluid={false} />

<section class="py-8 py-md-11 border-bottom">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-md-10 col-lg-10 text-center">
                <!-- Headin -->
                <h1 class="display-2">
                    {$_("about.opensource")} <br />
                    {$_("about.opencollaboration")}
                </h1>

                <!-- Text -->
                <p class="lead text-muted mb-7 mb-md-9">
                    {$_("about.description")}
                </p>
            </div>
        </div>
        <!-- / .row -->
    </div>
    <!-- / .container -->
</section>

<!-- WELCOME
    ================================================== -->
<section class="pt-8 pt-md-0 border-bottom">
    <div class="container">
        <div class="row align-items-stretch">
            <div class="col-12 col-md-6 offset-md-1 order-md-2">
                <!-- Slider (mobile) -->
                <div class="d-md-none img-cover">
                    <div class="w-100">
                        <!-- Image -->
                        <img
                            src="{$appManager.PublicUrl}img/photos/bicycles-and-busses-london-2.jpg"
                            alt="..."
                            class="img-fluid" />
                    </div>
                </div>

                <!-- Slider -->
                <div class="position-relative h-100 vw-50 d-none d-md-block">
                    <!-- Slider -->
                    <div
                        class="flickity-button-bottom flickity-button-white h-100 w-100">
                        <div
                            class="w-100 h-100 bg-cover"
                            style="background-image: url({$appManager.PublicUrl}img/photos/bicycles-and-busses-london-2.jpg);" />
                    </div>

                    <!-- Shape -->
                    <div
                        class="shape shape-start shape-fluid-y svg-shim text-white">
                        <AngleLeft />
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-5 py-8 py-md-8 order-md-1">
                <!-- Heading -->
                <h2>{$_("about.multimodal.title")}</h2>

                <!-- Text -->
                <p class="font-size-lg text-gray-700 mb-6">
                    {$_("about.multimodal.inlondon")}
                </p>

                <!-- Stats -->
                <div class="d-flex">
                    <div class="pe-5">
                        <h3 class="text-success mb-0">
                            <span>26</span>%
                        </h3>
                        <p class="text-gray-700 mb-0">
                            {$_("about.multimodal.walk")}
                        </p>
                    </div>
                    <div class="border-left border-gray-300" />
                    <div class="px-5">
                        <h3 class="text-success mb-0">
                            <span>37</span>%
                        </h3>
                        <p class="text-gray-700 mb-0">
                            {$_("about.multimodal.transit")}
                        </p>
                    </div>
                    <div class="border-left border-gray-300" />
                    <div class="ps-5">
                        <h3 class="text-success mb-0">
                            <span>37</span>%
                        </h3>
                        <p class="text-gray-700 mb-0">
                            {$_("about.multimodal.private")}
                        </p>
                    </div>
                </div>

                <!-- Text -->
                <p class="font-size-lg text-gray-700 mt-6">
                    {$_("about.multimodal.description")}
                </p>
            </div>
        </div>
        <!-- / .row -->
    </div>
    <!-- / .container -->
</section>

<section class="pt-8 p-md-8 border-bottom">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-md-10 col-lg-10 text-center">
                <!-- Headin -->
                <h2 class="display-3">{$_("about.team.title")}</h2>

                <!-- Text -->
                <p class="lead text-muted mb-7 mb-md-9">
                    {$_("about.team.intouch")}
                </p>
            </div>
        </div>
        <!-- / .row -->

        <div class="form-row justify-content-center">
            <div class="col-12 col-sm-8 col-md-12 col-xl-12">
                <!-- Image -->
                <div class="row justify-content-center">
                    <div class="col-12 col-sm-12 col-md-6 col-xl-3 d-flex">
                        <div class="card shadow-dark-lg mb-3">
                            <div class="card-body  text-center">
                                <div class="us-container">
                                    <div class="avatar avatar-xxl mb-3">
                                        <img
                                            src="{$appManager.PublicUrl}img/photos/us/ben.png"
                                            alt="..."
                                            class="avatar-img rounded-circle" />
                                    </div>
                                    <h4
                                        class="card-title font-weight-bold us-header">
                                        Ben Abelshausen
                                    </h4>
                                    <p class="card-text">
                                        {$_("about.team.ben.title")}
                                    </p>
                                    <!-- Meta -->
                                </div>
                                <div class="row m-3">
                                    <div class="col-4">
                                        <a
                                            href="https://twitter.com/xivk"
                                            class="text-decoration-none">
                                            <img
                                                src="{$appManager.PublicUrl}img/icons/social/twitter.svg"
                                                class="list-social-icon"
                                                alt="..." />
                                        </a>
                                    </div>
                                    <div class="col-4">
                                        <a
                                            href="https://github.com/xivk/"
                                            class="text-decoration-none">
                                            <img
                                                src="{$appManager.PublicUrl}img/icons/social/github.svg"
                                                class="list-social-icon"
                                                alt="..." />
                                        </a>
                                    </div>
                                    <div class="col-4">
                                        <a
                                            href="https://www.linkedin.com/in/benabelshausen/"
                                            class="text-decoration-none">
                                            <img
                                                src="{$appManager.PublicUrl}img/icons/social/linkedin.svg"
                                                class="list-social-icon"
                                                alt="..." />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6 col-xl-3 d-flex">
                        <div class="card shadow-dark-lg mb-3">
                            <div class="card-body  text-center">
                                <div class="us-container">
                                    <div class="avatar avatar-xxl mb-3">
                                        <img
                                            src="{$appManager.PublicUrl}img/photos/us/wim.png"
                                            alt="..."
                                            class="avatar-img rounded-circle" />
                                    </div>
                                    <h4
                                        class="card-title font-weight-bold us-header">
                                        Wim Michiels
                                    </h4>
                                    <p class="card-text">
                                        {$_("about.team.wim.title")}
                                    </p>
                                </div>
                                <!-- Meta -->
                                <div class="row m-3">
                                    <div class="col-6">
                                        <a
                                            href="https://twitter.com/WimMichiels76"
                                            class="text-decoration-none">
                                            <img
                                                src="{$appManager.PublicUrl}img/icons/social/twitter.svg"
                                                class="list-social-icon"
                                                alt="..." />
                                        </a>
                                    </div>
                                    <div class="col-6">
                                        <a
                                            href="https://www.linkedin.com/in/wim-michiels-a0a6869/"
                                            class="text-decoration-none">
                                            <img
                                                src="{$appManager.PublicUrl}img/icons/social/linkedin.svg"
                                                class="list-social-icon"
                                                alt="..." />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- / .container -->
</section>

<!-- BRANDS
================================================== -->
<section class="py-6 py-md-8 border-bottom">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-md-10 col-lg-10 text-center">
                <!-- Headin -->
                <h2 class="display-3">{$_("about.memberships.title")}</h2>

                <!-- Text -->
                <p class="lead text-muted mb-7 mb-md-9">
                    {$_("about.memberships.description")}
                </p>
            </div>
        </div>
        <!-- / .row -->
        <div class="row align-items-center justify-content-center">
            <div class="col-12 text-center client-logos">
                <a href="https://openstreetmap.be/"
                    ><img
                        src="{$appManager.PublicUrl}img/memberships/osm-belgium.svg"
                        alt="OSM Belgium" /></a>
                <a href="https://its.be/"
                    ><img
                        src="{$appManager.PublicUrl}img/memberships/its-belgium.jpg"
                        alt="ITS Belgium" /></a>
            </div>
        </div>
        <!-- / .row -->
    </div>
    <!-- / .container -->
</section>

<Footer bgClass="bg-gray-200" />
